import { render, staticRenderFns } from "./dormRoomBed.vue?vue&type=template&id=6a1e5eb8&"
import script from "./dormRoomBed.vue?vue&type=script&lang=js&"
export * from "./dormRoomBed.vue?vue&type=script&lang=js&"
import style0 from "./dormRoomBed.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports